<template>
    <div class="result-head">
        <div class="result-head-re">
            <span >上次考试时间：{{data.exam.start_time}} 至 {{data.exam.end_time}}</span>
            <span>
                <span  class="result-head-sum">
                    得分：<span>{{data.exam.score}} </span>分</span>共{{data.exam.questionSort.length}}題 總分{{data.exam.score}}分
                </span>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        data:{
            type:[Object],
        }
    },
    data(){
        return {
            
        }
    },
    components:{
    }
}
</script>
<style lang="less" scoped>
.result-head{
    flex: 1;
    &-re{
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        color:rgba(51,51,51,0.50);
        display: flex;
        justify-content: space-between;
        background:rgba(244,244,249,1);
        padding: 0 18px;
        .result-head-sum{
            margin-right: 14px;
            >span{
                color: #1AAD19;
            }
        }
    }
}
</style>